// ==========================================
// src/pages/AdminSignup.js
// ==========================================

import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { signupAdmin } from "../services/authService.js";

export default function AdminSignup() {

  const navigate = useNavigate();

  const [username, setUsername] =
    useState("");

  const [email, setEmail] =
    useState("");

  const [password, setPassword] =
    useState("");

  const [role, setRole] =
    useState("admin");

  const [loading, setLoading] =
    useState(false);

  const [error, setError] =
    useState("");

  const handleSubmit = async (e) => {

    e.preventDefault();

    try {

      setLoading(true);
      setError("");

      await signupAdmin(
        username,
        email,
        password,
        role
      );

      alert(
        "Signup successful. Please login."
      );

      navigate("/login");

    } catch (err) {

      setError(
        err.response?.data?.message ||
        "Signup failed"
      );

    } finally {

      setLoading(false);

    }

  };

  return (

    <div className="section">

      <div className="container">

        <h2 style={{ textAlign: "center" }}>
          Admin Signup
        </h2>

        <form onSubmit={handleSubmit}>

          {/* USERNAME */}

          <input
            type="text"
            placeholder="Username"
            value={username}
            className="form-input"
            onChange={(e) =>
              setUsername(
                e.target.value
              )
            }
            required
          />

          {/* EMAIL */}

          <input
            type="email"
            placeholder="Email"
            value={email}
            className="form-input"
            onChange={(e) =>
              setEmail(
                e.target.value
              )
            }
            required
          />

          {/* PASSWORD */}

          <input
            type="password"
            placeholder="Password"
            value={password}
            className="form-input"
            onChange={(e) =>
              setPassword(
                e.target.value
              )
            }
            required
          />

          {/* ROLE SELECT */}

          <select
            value={role}
            className="form-input"
            onChange={(e) =>
              setRole(
                e.target.value
              )
            }
          >

            <option value="admin">
              Admin
            </option>

            <option value="manager">
              Manager
            </option>

            <option value="editor">
              Editor
            </option>

            <option value="viewer">
              Viewer
            </option>

          </select>

          {error && (

            <p style={{ color: "red" }}>
              {error}
            </p>

          )}

          <button
            type="submit"
            className="btn btn-primary"
          >

            {loading
              ? "Creating account..."
              : "Sign Up"}

          </button>

          <p style={{ marginTop: 10 }}>
            Already have an account?{" "}
            <Link to="/login">
              Login
            </Link>
          </p>

        </form>

      </div>

    </div>

  );

}